(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colab-florentina-leitner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fl-colab]').forEach((section) => {
    const video = section.querySelector('video');
    const button = section.querySelector('[data-fl-motion]');
    const pauseLabel = section.querySelector('[data-fl-pause]');
    const playLabel = section.querySelector('[data-fl-play]');
    if (!video || !button || !pauseLabel || !playLabel) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    const syncButton = () => {
      const paused = video.paused;
      button.setAttribute('aria-pressed', String(paused));
      pauseLabel.hidden = paused;
      playLabel.hidden = !paused;
    };

    const tryPlay = () => {
      if (reduceMotion.matches) {
        syncButton();
        return;
      }

      video.muted = true;
      const playRequest = video.play();
      if (playRequest && typeof playRequest.then === 'function') {
        playRequest.then(syncButton).catch(syncButton);
      } else {
        syncButton();
      }
    };

    const resumeOnFirstTouch = (event) => {
      if (event.target.closest('[data-fl-motion]')) return;
      tryPlay();
    };

    video.addEventListener('play', syncButton);
    video.addEventListener('pause', syncButton);
    video.addEventListener('canplay', tryPlay, { once: true });
    window.addEventListener('pageshow', tryPlay);
    document.addEventListener('touchstart', resumeOnFirstTouch, { once: true, passive: true });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) tryPlay();
    });

    if (reduceMotion.matches) {
      video.pause();
    } else {
      tryPlay();
    }

    button.addEventListener('click', () => {
      if (video.paused) {
        video.muted = true;
        video.play().catch(syncButton);
      } else {
        video.pause();
      }
    });

    syncButton();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
